module.exports = __webpack_public_path__ + "officialStatic/img/studentBg.a8ba063.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/studentBg.jpg
// module id = z44m
// module chunks = 0